import { useEffect } from 'react';

function useS7SmartCrop(ref) {
  useEffect(() => {
    const node = ref.current;
    if (!node || node.dataset.mode !== "smartcrop") return;
    const MAX_ATTEMPTS = 3;
    const INTERVAL = 3e3;
    const waitForS7 = () => new Promise((resolve, reject) => {
      let attempts = 0;
      const check = () => {
        if (typeof window.s7responsiveImage === "function") {
          resolve();
        } else if (++attempts < MAX_ATTEMPTS) {
          setTimeout(check, INTERVAL);
        } else {
          reject(new Error("s7responsiveImage not available after 3 attempts"));
        }
      };
      check();
    });
    const applySmartCrop = async () => {
      try {
        await waitForS7();
        window.s7responsiveImage?.(node);
      } catch (err) {
        console.warn(err.message);
      }
    };
    if (document.readyState === "complete") {
      applySmartCrop();
    } else {
      window.addEventListener("load", applySmartCrop);
      return () => window.removeEventListener("load", applySmartCrop);
    }
  }, [ref]);
}

export { useS7SmartCrop };
